// extracted by mini-css-extract-plugin
export default {"cls1":"HChAZ5117KojHZISJJ_a","cls2":"UimMrHmaASduCS4RNfx5 HChAZ5117KojHZISJJ_a"};